import CreatedBotStats from "./CreatedBotStats";

/**
 * 🏗 Model used for general bot stats overview
 */
export default class BotTypeStats {
  constructor(
    public botStrategy: string,
    public name: string,
    public description: string,
    public image: string,
    public numberOfBots: number,
    public totalTrades: number,
    public averageTradesPerMonth: number,
    public averageDuration: number,
    public averageRoiPerBot: number,
    public averageRoiPerMonth: number,
    public averageRoiPerTrade: number,
    public averageBaHRoiMonth: number,
    public dayRoi: number,
    public weekRoi: number,
    public monthRoi: number,
    public averageSharpe: number,
    public averageSortino: number,
    public averageMaximumDrawdown: number,
    public performancePerMarket: any[],
    public bestPerformingMarkets: any[],
    public createdBots: CreatedBotStats[]
  ) {}

  // 📦 The fraction percentage of bots that outperform the underlying market
  public get botsOutperformingTheMarket(): number {
    return this.createdBots.length > 0
      ? this.createdBots.filter((bot: CreatedBotStats) => bot.roi > bot.bahROI)
          .length / this.createdBots.length
      : 0;
  }

  public get averageMonthlyOutperformance() {
    return this.averageRoiPerMonth - this.averageBaHRoiMonth
  } 

  static examples: BotTypeStats[] = [
    new BotTypeStats(
      "sometestuid",
      "GRU-V3-56",
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim adminim veniam, quis nostrud exercitation ullamco laboris nisi utaliquip ex ea commodo consequat. Duis aute irure dolor inreprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
      "",
      23,
      120,
      45,
      12,
      2.56,
      5.55,
      4.54,
      3.4,
      0.012,
      0.0945,
      0.1532,
      3,
      3,
      3,
      [],
      [],
      []
    ),
    new BotTypeStats(
      "sometestuid2",
      "GRU-V2-45",
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim adminim veniam, quis nostrud exercitation ullamco laboris nisi utaliquip ex ea commodo consequat. Duis aute irure dolor inreprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
      "",
      10,
      230,
      40,
      12,
      3.56,
      2.75,
      7.63,
      3.4,
      0.012,
      0.0945,
      0.1532,
      3,
      3,
      3,
      [],
      [],
      []
    ),
  ];
}
